import { toTitleCase } from "lib";
import { faCaretLeft } from "@fortawesome/pro-solid-svg-icons";
import { getReportIcon } from "lib/reports";

interface BuildBusinessUserSubNavReportButtonsFunction {
  (
    reportLinksByAgencyName: Record<string, Array<MinifiedReportLink>>,
  ): Array<MultiButtonActionButton>;
}

export const buildBusinessUserSubNavReportButtons: BuildBusinessUserSubNavReportButtonsFunction =
  reportLinksByAgencyName => {
    const reportButtons: MultiButtonActionButton[] = [];

    Object.entries(reportLinksByAgencyName).forEach(([agencyName, rLinks]) => {
      reportButtons.push({
        subMenuItemsTitle: toTitleCase(agencyName),
        title: toTitleCase(agencyName),
        icon: faCaretLeft,
        subNavItems: rLinks.map(link => ({
          title: link.name,
          icon: getReportIcon(link),
          onClick: () => window.open(link.url, "_blank"),
        })),
      });
    });

    return reportButtons;
  };
